/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/function-component-definition */
import { getJSON } from '@folklore/fetch';
import { useFieldComponent, useFieldsValue } from '@micromag/core/contexts';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';

const propTypes = {
    value: PropTypes.shape({
        domain: PropTypes.string,
    }),
    token: PropTypes.string,
    onChange: PropTypes.func,
};

const defaultProps = {
    value: null,
    token: null,
    onChange: null,
};

function KioskDomainField({ token, value: providedValue, onChange, ...props }) {
    const { domain: providedDomain = null } = useFieldsValue() || {};
    const value =
        providedDomain !== null
            ? {
                  domain: providedDomain,
                  ...providedValue,
              }
            : providedValue;
    const UrlField = useFieldComponent('url');
    const onFieldChange = useCallback(
        (newValue) => {
            if (onChange !== null) {
                onChange(
                    newValue !== null && newValue.length > 0
                        ? {
                              ...value,
                              domain: newValue,
                          }
                        : null,
                );
            }
        },
        [onChange, value],
    );

    const { domain = null } = value || {};
    useEffect(() => {
        if (domain === null || domain.match(/^https?:\/\/([^/]+)\/?/) === null) {
            return () => {};
        }
        let canceled = false;
        const timeout = setTimeout(() => {
            getJSON(`${domain.replace(/^(https?:\/\/[^/]+)\/?/, '$1')}/api/kiosk`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                if (canceled) {
                    return;
                }
                if (onChange !== null) {
                    onChange({
                        ...response,
                        domain,
                    });
                }
            });
        }, 1000);
        return () => {
            clearTimeout(timeout);
            canceled = true;
        };
    }, [domain, token]);

    return (
        <UrlField
            value={domain !== null ? domain.replace(/^(https?:\/\/[^/]+)\/?/, '$1') : null}
            onChange={onFieldChange}
            {...props}
        />
    );
}

KioskDomainField.propTypes = propTypes;
KioskDomainField.defaultProps = defaultProps;

export default KioskDomainField;
